import module from 'viaticos/module.js'

export class ViaticosCatalgosProyectosService {
  constructor ($http) {
    this.$http = $http
  }

  get (id_pagadora) {
    return this.$http.get('/api/viaticos/catalogos/proyectos')
  }
}

module.service('ViaticosCatalgosProyectosService', ViaticosCatalgosProyectosService)



// WEBPACK FOOTER //
// ./src/viaticos/services/Catalogos/Proyectos.js